import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-2">
        <div className="h-9 w-20 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList>
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="px-4 py-2 text-sm font-medium text-foreground hover:text-primary transition-colors duration-[var(--duration-medium)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  return <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center focus-ring rounded-md">
              <img src="https://arangroup.net/wp-content/uploads/2025/10/website_logo_main-1.png" alt="Aran Group" className="h-7" />
            </Link>
          </div>

          <nav className="hidden md:flex items-center gap-6">
            <MenuProvider menu_id="17">
              <HeaderMenuConsumer />
            </MenuProvider>
          </nav>

          <div className="flex items-center gap-4">
            <Button asChild className="btn-primary">
              <Link to="/ContactPage">
                <Phone className="size-4" />
                Contact Us
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </header>;
}